import React, { useEffect, useRef } from 'react';
import './App.scss';
import { addEventListenerToResizeGame, isMobile, resizeGame } from './platform/utils';
import { screenSize } from './platform/constants';
import { Main } from './modules/main/Main';
import { gameService } from './platform/services';

function App() {
  const root = useRef(null);
  useEffect(() => {
    if (!isMobile()) {
      resizeGame(screenSize.height, screenSize.width, root.current);
      addEventListenerToResizeGame();
    }

    gameService.initializeGame();
  });

  return (
    <div className="background flex-center">
      <div className={`root ${isMobile() ? 'mobile' : ''}`} ref={root}>
        <Main/>
      </div>
    </div>
  );
}

export default App;
